<template lang="pug">
  .ScrollTop(@click="scrollTop")

    .ScrollTop_label Top
    .ScrollTop_line
      span.first
      span.second
</template>

<script>

import { TweenLite, ScrollToPlugin, Power4 } from 'gsap/all'

const plugins = [ScrollToPlugin]

export default {
  methods: {
    scrollTop () {
      TweenLite.to(document.body.querySelector('.MainContainer'), 2, {scrollTo: 0, ease: Power4.easeOut})
    }
  }
}

</script>

<style lang="stylus" scoped>

.ScrollTop

  position fixed
  cursor n-resize
  bottom 0px
  display flex
  flex-direction column
  align-items center
  right 65px

  @media $mq_s_only

    display none

  &_line

    height 100px
    width 1px
    position relative
    overflow hidden
    margin-top 30px

    span

      position absolute
      background-color $grey-1
      width 100%
      height 100%
      display block
      left 0px
      top 0px
      transition all 2s $ease

      &.first

        top 0px
        transform-origin left top
        transition-delay 0.2s

      &.second

        transform scaleY(0)
        transition-delay 0s
        transform-origin left bottom

  &_label

    transform: rotate(-90deg);
    font-weight 600
    font-size: 12px;
    color: $grey-1
    letter-spacing: 5px;

  &:hover

    .ScrollTop_line

      span

        &:nth-child(1)

          transform scaleY(0)
          transition-delay 0s
          transform-origin left top

        &:nth-child(2)

          transform scaleY(1)
          transform-origin left bottom
          transition-delay 0.25s

@keyframes scrollLine-2
  0%
    transform: scale(1, 0);
    transform-origin: left bottom;

  40%
    transform: scale(1, 0);
    transform-origin: left bottom;

  80%
    transform: scale(1, 1);
    transform-origin: left bottom;

  80.1%
    transform: scale(1, 1);
    transform-origin: left top;

  100%
    transform: scale(1, 0);
    transform-origin: left top;

@keyframes scrollLine

  0%
    transform: scale(1, 1);
    transform-origin: left top;

  20%
    transform: scale(1, 0);
    transform-origin: left top;

  20.1%
    transform: scale(1, 0);
    transform-origin: left bottom;

  70%
    transform: scale(1, 1);
    transform-origin: left bottom;

  100%
    transform: scale(1, 1);
    transform-origin: left bottom;

</style>
